import { render, staticRenderFns } from "./OverlayComponent.vue?vue&type=template&id=5c549ef3&"
import script from "./OverlayComponent.vue?vue&type=script&lang=ts&"
export * from "./OverlayComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OverlayComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports